import React from 'react';

export const NoDataOverlay = ({show, children}) => (
  <div style={{position: 'relative', width: '100%', height: '100%'}}>
    <div style={{
            filter: show ? 'blur(2px)' : 'none',
            pointerEvents: show ? 'none' : 'auto',
            transition: 'filter 0.3s ease',
            height: '100%',
        width: '100%',
        }}
    >
      {children}
    </div>

    {show && (
      <div style={{
                position: 'absolute',
                inset: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'rgba(255, 255, 255, 0.6)',
                backdropFilter: 'blur(2px)',
                zIndex: 10,
                fontSize: '18px',
                color: '#666',
            }}
      >
        No data to show
      </div>
        )}
  </div>
);
